import { resolveScanStatusValue } from './statusNormalization';
import {
  isFailedStatus,
  isSuccessfulStatus,
  isTerminalScanStatus,
  isVirusStatus
} from './statusPredicates';

export function resolveStatusLabel(status) {
  const normalized = resolveScanStatusValue(status);

  if (!normalized || normalized === 'idle' || normalized === 'pending' || normalized === 'ready') {
    return 'Ready';
  }

  if (normalized === 'uploading' || normalized === 'busy') {
    return 'Uploading';
  }

  if (normalized === 'uploaded' || normalized === 'scanning' || normalized === 'scan') {
    return 'Scanning';
  }

  if (isSuccessfulStatus(normalized)) {
    return 'Clean';
  }

  if (normalized === 'quarantined' || normalized === 'quarantine' || isVirusStatus(normalized)) {
    return 'Quarantined';
  }

  if (normalized === 'failed' || isFailedStatus(normalized)) {
    return 'Error In Upload';
  }

  return 'Unknown';
}

export function resolveScanStatusTitle(label, status) {
  return `${label}: ${resolveStatusLabel(status)}`;
}

export function resolveMediaIconTone(item) {
  const scanStatus = resolveScanStatusValue(item?.scanStatus);

  if (isVirusStatus(scanStatus)) {
    return 'quarantine';
  }

  if (item?.mediaUploadStatus === 'error' || scanStatus === 'failed' || isFailedStatus(scanStatus)) {
    return 'failed';
  }

  if (item?.mediaUploadStatus === 'uploading') {
    return 'busy';
  }

  if (item?.mediaUploadStatus === 'completed' && !isTerminalScanStatus(scanStatus)) {
    return 'scan';
  }

  if (scanStatus === 'scanning' || scanStatus === 'uploaded') {
    return 'scan';
  }

  if (item?.mediaUploadStatus === 'idle' && (scanStatus === 'pending' || scanStatus === 'ready')) {
    return 'ready';
  }

  if (isSuccessfulStatus(scanStatus)) {
    return 'clean';
  }

  return 'ready';
}

export function resolveMediaUploadTitle(item) {
  return resolveScanStatusTitle('Media', resolveMediaIconTone(item));
}

export function resolveTranscriptIconTone(item) {
  if (!item?.transcriptEnabled) {
    return 'ready';
  }

  const scanStatus = resolveScanStatusValue(item?.transcriptScanStatus);

  if (isVirusStatus(scanStatus)) {
    return 'quarantine';
  }

  if (item?.transcriptUploadStatus === 'error' || scanStatus === 'failed' || isFailedStatus(scanStatus)) {
    return 'failed';
  }

  if (item?.transcriptUploadStatus === 'uploading') {
    return 'busy';
  }

  if (item?.transcriptUploadStatus === 'completed' && !isTerminalScanStatus(scanStatus)) {
    return 'scan';
  }

  if (scanStatus === 'scanning' || scanStatus === 'uploaded') {
    return 'scan';
  }

  if (item?.transcriptUploadStatus === 'idle' && item?.transcriptFile) {
    return 'ready';
  }

  if (isSuccessfulStatus(scanStatus)) {
    return 'clean';
  }

  return 'ready';
}

export function resolveTranscriptUploadTone(item) {
  return resolveTranscriptIconTone(item);
}

export function resolveTranscriptUploadTitle(item) {
  return resolveScanStatusTitle('Transcript', resolveTranscriptIconTone(item));
}

export function getUploadRowPresentation(item, isLocalUploadFailed) {
  const mediaVirus = isVirusStatus(item?.scanStatus);
  const transcriptVirus = isVirusStatus(item?.transcriptScanStatus);
  const isVirusRow = mediaVirus || transcriptVirus;
  const isRejectedRow = isVirusRow || isLocalUploadFailed(item);

  return {
    mediaVirus,
    transcriptVirus,
    isVirusRow,
    isRejectedRow,
    mediaTone: resolveMediaIconTone(item),
    transcriptTone: resolveTranscriptUploadTone(item),
    mediaDeleteButtonStyle: mediaVirus ? { color: '#b91c1c' } : { color: '#64748b' },
    transcriptDeleteButtonStyle: transcriptVirus ? { color: '#b91c1c' } : { color: '#64748b' }
  };
}
